import http from './HttpService';
import CountryUtils from '../utils/country-utils';
import UrlUtils from '../utils/url-utils/UrlUtils';

import urls from '../constants/Urls';
import { countryCodes } from '../constants/CountryCodes';

import { WEB_PLATFORM_IS_ENVIRONMENT } from 'shared/infra/constants/platform.const';

const countriesServiceBaseURL = process.env.REACT_APP_PARTNER_BASE_URL;

const getAllAvailable = async () => {
  let { data: availableCountries } = await http.get(
    `${countriesServiceBaseURL}${urls.GET_ALL_AVAILABLE_COUNTRIES}`,
  );

  if (WEB_PLATFORM_IS_ENVIRONMENT.development) {
    availableCountries = availableCountries.filter(
      country => country.code === countryCodes.COLOMBIA,
    );
  }

  availableCountries = availableCountries.map(country => {
    return {
      ...country,
      flag: country.flag && country.flag.replace('http://', 'https://'),
    };
  });
  return CountryUtils.sortByName(availableCountries);
};

const resolveCountry = (lat, lng) => {
  const params = { lat, lng };
  const uriWithParams = UrlUtils.replaceUrlParams(urls.RESOLVE_COUNTRY, params);
  return http.get(`${countriesServiceBaseURL}${uriWithParams}`);
};

export default {
  getAllAvailable,
  resolveCountry,
};
